import { getStore } from 'app/state/storeRegistry'
import { createDialogOpener } from 'features/dialogs/openDialog'
import { pushDialog } from 'features/dialogs/state/dialogsSlice'

export const showVariablesDialog = (workflowId: string) =>
  getStore().dispatch(
    pushDialog({
      factory: () => import('./VariablesDialog'),
      dialogProps: { workflowId }
    })
  )

export const showExportWorkflowDialog = (workflowId: string) =>
  getStore().dispatch(
    pushDialog({
      factory: () => import('./ExportWorkflowDialog'),
      dialogProps: { workflowId }
    })
  )

export const showDeleteImportedTableDialog = (filename: string, onConfirm: () => void) =>
  getStore().dispatch(
    pushDialog({
      factory: () => import('./DeleteImportedTableDialog'),
      dialogProps: { filename, onConfirm }
    })
  )

export const showApiEndpointDialog = (workflowId: string) =>
  getStore().dispatch(
    pushDialog({
      factory: () => import('./ApiEndpointDialog'),
      dialogProps: { workflowId }
    })
  )

export const showMcpToolDialog = (workflowId: string) =>
  getStore().dispatch(
    pushDialog({
      factory: () => import('./McpToolDialog'),
      dialogProps: { workflowId }
    })
  )

export const showSelectConnectionDialog = createDialogOpener(() => import('./SelectConnectionDialog'))

export const showWorkflowEditNameDialog = createDialogOpener(
  () => import('./WorkflowEditNameDialog/WorkflowEditNameDialog')
)

export const showWorkflowShareDialog = createDialogOpener(() => import('./WorkflowShareDialog/WorkflowShareDialog'))

export const showSelectTemplateDialog = createDialogOpener(() => import('./SelectTemplateDialog/SelectTemplateDialog'))

export const showDeleteConfirmationDialog = createDialogOpener(
  () => import('./WorkflowDeleteDialog/WorkflowDeleteDialog')
)
